import { isSSR } from 'utils';

export const isTest = (): boolean | undefined => {
  if (!isSSR) {
    const { hostname } = window.location;
    return hostname === 'test' || hostname === 'test.payhour.isdemo.se';
  }
};
